export const HIDE_SHARE = 'hide-share';
export const SURVEY_COUNT = 'survey-count';
export const OPTIONAL_EXCERCISES_CONFIG = 'optional-excercises-config';
export const SOUND_CONFIG = 'sound-config';

export const saveHideShare = (bool) => localStorage.setItem(HIDE_SHARE, bool);

export const getHideShare = () =>
	localStorage.getItem(HIDE_SHARE)
		? localStorage.getItem(HIDE_SHARE) === 'true'
		: false;

export const saveSurveyCount = (count) =>
	localStorage.setItem(SURVEY_COUNT, count);
export const getSurveyCount = () => Number(localStorage.getItem(SURVEY_COUNT));
export const hasSurveyCount = () => localStorage.hasOwnProperty(SURVEY_COUNT);

const defaultOptionalConfig = {wantsWarmup: true, wantsCooldown: true};

export const saveOptionalExcercisesConfig = (config = defaultOptionalConfig) =>
	localStorage.setItem(OPTIONAL_EXCERCISES_CONFIG, JSON.stringify(config));

export const getOptionalExcercisesConfig = () => {
	const config = localStorage.getItem(OPTIONAL_EXCERCISES_CONFIG);
	return config ? JSON.parse(config) : defaultOptionalConfig;
};

export const clearOptionalExcercisesConfig = () =>
	localStorage.removeItem(OPTIONAL_EXCERCISES_CONFIG);

export const setWantsSounds = (wish) => {
	localStorage.setItem(SOUND_CONFIG, JSON.stringify({wantsSound: wish}));
};
export const getWantsSounds = () => {
	const config = JSON.parse(localStorage.getItem(SOUND_CONFIG));
	if (!config) {
		return true;
	}
	const {wantsSound} = config;
	return wantsSound;
};

export const clearWantsSounds = () => localStorage.removeItem(SOUND_CONFIG);



// WEBPACK FOOTER //
// ./src/utils/settingsStore.js